{
    "NAME": "BeheerderOverzichtTaal",
    "AdminOverview_Intro": "Selecteer een CME, telefonieserver en partitie om de beschikbare beheerdersgebieden en het huidige aantal te bekijken.",
    "AdminOverview_Search_Helper": "De zoekopdracht is van toepassing op de hier weergegeven aantallen en wordt doorgevoerd naar de geselecteerde beheerderspagina.",
    "AdminOverview_State_Loading": "Laden",
    "AdminOverview_State_Error": "Het is niet mogelijk om het meest recente aantal te laden.",
    "AdminOverview_State_NoTelephonyServer": "Geen telefoonserver binnen het bereik",
    "AdminOverview_State_SelectTelephonyServer": "Selecteer een telefonieserver om dit aantal te laden.",
    "AdminOverview_State_SelectTelephonyServerAndPartition": "Selecteer een telefonieserver en partitie om dit aantal te laden.",
    "AdminOverview_State_SelectPartition": "Selecteer een specifieke partitie om dit aantal te bekijken.",
    "AdminOverview_State_MessagesLegacy": "Legacy-beheerpagina",
    "AdminOverview_State_DatabaseLegacy": "Legacy-beheerpagina",
    "AdminOverview_Tile_Cme_Title": "CME's",
    "AdminOverview_Tile_Cme_Subtitle": "Servicestructuur",
    "AdminOverview_Tile_Cme_Summary": "Nascholing voor kinderen",
    "AdminOverview_Tile_Cme_Aria": "Open CME's",
    "AdminOverview_Tile_Telsys_Title": "Telefoonservers",
    "AdminOverview_Tile_Telsys_Subtitle": "Platformterrein",
    "AdminOverview_Tile_Telsys_Summary": "Totaal aantal servers",
    "AdminOverview_Tile_Telsys_Aria": "Open telefonieservers",
    "AdminOverview_Tile_Partitions_Title": "Partities",
    "AdminOverview_Tile_Partitions_Subtitle": "Partitiebereik",
    "AdminOverview_Tile_Partitions_Summary": "Partities",
    "AdminOverview_Tile_Partitions_Aria": "Open partities",
    "AdminOverview_Tile_Users_Title": "Gebruikers",
    "AdminOverview_Tile_Users_Subtitle": "Toegang tot de applicatie",
    "AdminOverview_Tile_Users_Summary": "Gebruikers",
    "AdminOverview_Tile_Users_Aria": "Open gebruikers",
    "AdminOverview_Tile_Devices_Title": "Apparaten",
    "AdminOverview_Tile_Devices_Subtitle": "Eindpuntinventarisatie",
    "AdminOverview_Tile_Devices_Summary": "Apparaten",
    "AdminOverview_Tile_Devices_Aria": "Open apparaten",
    "AdminOverview_Tile_Devices_Extension": "Verlenging",
    "AdminOverview_Tile_Devices_ExtensionTrunking": "Uitbreiding (Trunking)",
    "AdminOverview_Tile_Devices_ExtensionHospitality": "Uitbreiding (Gastvrijheid)",
    "AdminOverview_Tile_Devices_Groups": "Groepen",
    "AdminOverview_Tile_Devices_AutoAttendant": "Automatische beantwoorder",
    "AdminOverview_Tile_Agents_Title": "Agenten",
    "AdminOverview_Tile_Agents_Subtitle": "Wachtrijbewerkingen",
    "AdminOverview_Tile_Agents_Summary": "Agenten",
    "AdminOverview_Tile_Agents_Aria": "Open agenten",
    "AdminOverview_Tile_Directory_Title": "Directory",
    "AdminOverview_Tile_Directory_Subtitle": "Contactgegevens",
    "AdminOverview_Tile_Directory_Summary": "Gidsen",
    "AdminOverview_Tile_Directory_Aria": "Open Directory",
    "AdminOverview_Tile_Codes_Title": "Codes",
    "AdminOverview_Tile_Codes_Subtitle": "Codebeheer",
    "AdminOverview_Tile_Codes_Summary": "Codes",
    "AdminOverview_Tile_Codes_Aria": "Open Codes",
    "AdminOverview_Tile_Recording_Title": "Opname",
    "AdminOverview_Tile_Recording_Subtitle": "Integraties",
    "AdminOverview_Tile_Recording_Summary": "Opnames",
    "AdminOverview_Tile_Recording_Aria": "Openbare opname",
    "AdminOverview_Tile_Messages_Title": "Berichten",
    "AdminOverview_Tile_Messages_Subtitle": "Verouderde tools",
    "AdminOverview_Tile_Messages_Aria": "Open berichten",
    "AdminOverview_Tile_Database_Title": "Database",
    "AdminOverview_Tile_Database_Subtitle": "Verouderde tools",
    "AdminOverview_Tile_Database_Aria": "Open database"
}